import { createFileRoute } from '@tanstack/react-router';
import SupportGuides from '@pages/Support/SupportGuides';

export const Route = createFileRoute('/support/support-guides')({
  component: SupportGuides,
});
